export default {
  "content": "<path d=\"M12.83 10.175l-.84-.61.99-1.25-1.54-.45.32-.99 1.5.56-.06-1.61h1.04l-.06 1.61 1.5-.56.32.99-1.54.45.99 1.25-.84.61-.89-1.32-.9 1.32h.01zm-5.72 0l-.84-.61.99-1.25-1.54-.45.32-.99 1.5.56-.06-1.61h1.04l-.06 1.61 1.5-.56.32.99-1.54.45.99 1.25-.84.61L8 8.855l-.9 1.32h.01zm-5.72 0l-.84-.61.99-1.25L0 7.865l.32-.99 1.5.56-.06-1.61H2.8l-.06 1.61 1.5-.56.32.99-1.54.45.99 1.25-.84.61-.89-1.32-.9 1.32h.01z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};